export default {
  // 教学班级
  classList:'',
  wacom: {},
  classStudentList:'',
  classGroupStuList:'',
  classInfo:{
    del:'',
    delClassStu:'',
    basic:'',
    user:'',
    student:'',
    basicEdit:'',
    addStu:'',
    classGroup:'',
    addGroup:'',
    addGroupStu:'',
    editGroup:'',
    delGroup:'',
    batchGroup:'',
    randomStu:'',
    editGroupStu:''
   },
}
